import { render, staticRenderFns } from "./ChargeSummary.vue?vue&type=template&id=8895c6a4&scoped=true"
import script from "./ChargeSummary.vue?vue&type=script&lang=js"
export * from "./ChargeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8895c6a4",
  null
  
)

export default component.exports